import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreferenciasSuscripcionComponent } from './preferencias-suscripcion/preferencias-suscripcion.component';
import { SuscripcionRoutingModule } from './suscripcion-routing.module';

@NgModule({
  declarations: [
    PreferenciasSuscripcionComponent
  ],
  imports: [
    CommonModule,
    SuscripcionRoutingModule
  ]
})
export class SuscripcionModule {

  static get nombreRuta(): string {
    return 'SuscripcionModule';
  }
 }
